import GameSoundVars from '../../../game/src/enums/GameSoundVars';
import App from '../../core/src/App';
import WinlinesView from '../../core/src/views/WinlinesView';
import BetModel from '../../core/src/model/BetModel';
import SpinModel from '../../core/src/model/SpinModel';
import ConsoleUtil from '../../core/src/utils/ConsoleUtil';
import SoundController from '../../core/src/utils/SoundController';
import { Ease } from '../../core/src/Ease';
import { Timeline } from '../../core/src/Timeline';
import { Tween } from '../../core/src/Tween';
import GameEvents from '../../core/src/const/GameEvents';
import SoundVars from '../../core/src/const/SoundVars';
import GameModel from '../../core/src/model/GameModel';
import { DefaultLayers } from '../../core/src/utils/Layers';
import ViewManager from '../../core/src/utils/ViewManager';
import { BitmapMoneyField } from '../../core/src/views/BitmapMoneyField';


export default class VendorWinlinesView extends WinlinesView {

    // allow you to configure more than one win line sound
    protected winThresholds: { winRatio: number, name: string }[] = App.config.winSoundRatioThresholds;
    protected winLevelNames =
        ["ante_win", "small_win", "nice_win", "excellent_win"]
        || GameModel.gameConfig.winLevelNames;

    protected blinkAnimationPercentages: number[];

    constructor(supportOrientationChange = false) {
        super(supportOrientationChange);
        this.blinkAnimationPercentages = [20, 20, 30, 20];
    }

    protected playWinSound() {
        if (this.winThresholds) {
            let winSound: string = this.winThresholds[0].name;

            const profit = Math.round(SpinModel.getAccumulatedWin() / BetModel.totalBet);

            this.winThresholds.forEach((threshold) => {
                if (profit >= threshold.winRatio) {
                    winSound = threshold.name;
                };
            });

            if (SoundController.hasSound(GameSoundVars[winSound])) {
                SoundController.playSound(GameSoundVars[winSound]);
            } else {
                ConsoleUtil.warn("sound not found! ", GameSoundVars[winSound]);
            }

        } else {  // use standar win sound
            super.playWinSound();
        }
    }

    protected getWinLevel(): string {
        let winLevel: string = "";
        if (SpinModel.getCurrentWin() <= (1 * BetModel.totalBet)) {
            winLevel = this.winLevelNames[0];
        }
        else if ((SpinModel.getCurrentWin() < (3 * BetModel.totalBet))) {
            winLevel = this.winLevelNames[1];
        }
        else if ((SpinModel.getCurrentWin() < (6 * BetModel.totalBet))) {
            winLevel = this.winLevelNames[2];
        } else {
            winLevel = this.winLevelNames[3];
        }
        return winLevel;
    }

    public setWinBannerValue(value: number, animate = false) {
        const layer = ViewManager.getLayer(DefaultLayers.PaylineCelebration);
        layer.clear();
        if (SpinModel.hasBigWin() && !SpinModel.respinsRunning) {
            this.playWinSound();
            this.emit(GameEvents.BANNER_ANIM_COMPLETE);
            return;
        }

        const scene = layer.setScene("totalWin");
        scene.sceneMoneyFields.forEach((field) => {
            field.visible = false;
        });
        this.winValueBanner = scene.sceneMoneyFields.get(
            this.getWinLevel()
        ) as BitmapMoneyField;
        this.winValueBanner.visible = true;

        let winSpine = scene.spineAnimations.get("totalWins");
        winSpine.play(this.getWinLevel())

        let wholeAnimDuration = winSpine.getAnimDuration(this.getWinLevel());
        let blinkValueDuration = (wholeAnimDuration / 100) * this.blinkAnimationPercentages[this.getWinLevel()];
        let bangupDuration = wholeAnimDuration - blinkValueDuration;

        if (animate) {
            this.winValueBanner.value = 0;
            const wincountSound = SoundController.playSound(
                SoundVars.EFFECT_WINCOUNT
            );
            this.winValueBannerBangUp.startBangup(
                0,
                value,
                bangupDuration,
                null,
                (currentVal) => {
                    this.winValueBanner.value = currentVal;
                },
                () => {
                    let w = this.winValueBanner.width;
                    let h = this.winValueBanner.height;
                    let x = this.winValueBanner.x;
                    let y = this.winValueBanner.y;

                    if (wincountSound) {
                        SoundController.stopSound(wincountSound);
                    }
                    let timeline = new Timeline({
                        autoRemoveChildren: true,
                        onComplete: () => {
                            this.playWinSound();
                            this.emit(GameEvents.BANNER_ANIM_COMPLETE);
                            this.winValueBanner.visible = false;
                            timeline.clear();
                            timeline.kill();
                        }
                    });
                    timeline
                        .to(this.winValueBanner,
                            blinkValueDuration / 2,
                            {
                                width: w * 1.3,
                                height: h * 1.3,
                                x: x - ((w * 1.3 - w) / 2),
                                y: y - ((h * 1.3 - h) / 2),
                                ease: Ease.None,
                            }, 0)
                        .to(this.winValueBanner,
                            blinkValueDuration / 2,
                            {
                                width: w,
                                height: h,
                                x: x,
                                y: y,
                                ease: Ease.None,
                            }, blinkValueDuration / 2)
                    timeline.play();
                }
            );
        } else {
            this.winValueBanner.value = value;
            this.playWinSound();
            Tween.delayedCall(wholeAnimDuration, () => {
                this.winValueBanner.visible = false;
                this.emit(GameEvents.BANNER_ANIM_COMPLETE);
            });
        }

        this.winValueBanner.visible = true;
    }
};
